import React from 'react';

const SectionDescription = ({title, subTitle, description}) => {

  return (
    <div className="section-header text-center mb-5">
      <br />
      <h2>{title}</h2>
      {subTitle != null && <h4>{subTitle}</h4>}
      {description != null && <p className="mb-0">{description}</p>}
    </div>
  );
};

export default SectionDescription;